import { getConfig } from './ConfigProvider';
import { OktaAuth } from '@okta/okta-auth-js';

let oktaAuth: OktaAuth;

export const getOktaAuth = () => {
  const config = getConfig();
  oktaAuth =
    oktaAuth ??
    new OktaAuth({
      issuer:
        config.OKTA_ISSUER,
      clientId: config.OKTA_CLIENT_ID,
      scopes: ['openid', 'profile', 'email', 'document_portal'],
      redirectUri: `${window.location.origin}${config.REACT_APP_BASE_PATH}/login/callback`,
      postLogoutRedirectUri: `${window.location.origin}${config.REACT_APP_BASE_PATH}`,
      ignoreLifetime: true,
      pkce: true,
      devMode: true,
    });

  return oktaAuth;
};
